// Pages
import { PERMISION } from "security"
import Find from "pages/FindSection"
import Journal from "pages/Finance/Journal"
import FinanceRegister from "pages/Finance/Register"
import Dashboard from "pages/Finance/Transaction/Dashboard"
import GeneralEntryEdit from "pages/Finance/Transaction/GeneralEntry/Edit"
import ReceiveMoney from "pages/Finance/Transaction/ReceiveMoney"
import EditReceiveMoney from "pages/Finance/Transaction/ReceiveMoney/Edit"
import SpendMoney from "pages/Finance/Transaction/SpendMoney"
import EditSpendMoney from "pages/Finance/Transaction/SpendMoney/Edit"
import TransferMoney from "pages/Finance/Transaction/TransferMoney"
import TransferMoneyEdit from "pages/Finance/Transaction/TransferMoney/Edit"
import { ReconcileAccount } from "pages/Finance/Transaction/ReconcileAccount"

// Types
import type { RouteType } from "types"

export const financeRoutes: RouteType[] = [
  {
    path: "/finance/register/",
    element: <FinanceRegister />,
    permission: PERMISION.FINANCE.REGISTER.PERMISION
  },
  {
    path: "/finance/transaction/reconcile-account",
    element: <ReconcileAccount />,
    permission: PERMISION.FINANCE.TRANSACTION.RECONCILE_ACCOUNT.CREATE
  },
  {
    path: "/finance/report/dashboard",
    element: <Dashboard />,
    permission: PERMISION.FINANCE.REPORT.DASHBOARD.PERMISION
  },
  {
    path: "/finance/journal",
    element: <Journal />,
    permission: PERMISION.FINANCE.JOURNAL.PERMISION
  },
  {
    path: "/finance/transaction/general-entry/edit/:data_source/:data_source_id",
    element: <GeneralEntryEdit />,
    permission: PERMISION.FINANCE.TRANSACTION.PERMISION
  },
  {
    path: "/finance/transaction/receive-money",
    element: <ReceiveMoney />,
    permission: PERMISION.FINANCE.TRANSACTION.RECEIVE_MONEY.PERMISION
  },
  {
    path: "/finance/transaction/receive-money/edit/:data_source/:data_source_id",
    element: <EditReceiveMoney />,
    permission: PERMISION.FINANCE.TRANSACTION.RECEIVE_MONEY.UPDATE
  },
  {
    path: "/finance/transaction/spend-money",
    element: <SpendMoney />,
    permission: PERMISION.FINANCE.TRANSACTION.SPEND_MONEY.PERMISION
  },
  {
    path: "/finance/transaction/spend-money/edit/:data_source/:data_source_id",
    element: <EditSpendMoney />,
    permission: PERMISION.FINANCE.TRANSACTION.SPEND_MONEY.UPDATE
  },
  {
    path: "/finance/transaction/transfer-money",
    element: <TransferMoney />,
    permission: PERMISION.FINANCE.TRANSACTION.TRANSFER_MONEY.PERMISION
  },
  {
    path: "/finance/transaction/transfer-money/edit/:data_source/:data_source_id",
    element: <TransferMoneyEdit />,
    permission: PERMISION.FINANCE.TRANSACTION.TRANSFER_MONEY.UPDATE
  },
  {
    path: "/finance/register",
    element: <FinanceRegister />,
    permission: PERMISION.FINANCE.REGISTER.PERMISION
  },
  {
    path: "/finance/find",
    element: <Find />,
    permission: PERMISION.FINANCE.FIND.PERMISION
  },
  {
    path: "/finance/report/transaction-journal",
    element: <div />,
    permission: "FT"
  }, 
  {
    path: "/finance/report/bank-register",
    element: <div />,
    permission: "FT"
  },
  {
    path: "/finance/report/reconsilition-report",
    element: <div />,
    permission: "FT"
  },
  {
    path: "/finance/report/cast-flow-analysis",
    element: <div />,
    permission: "FT"
  },
  {
    path: "/finance/report/account-balance",
    element: <div />,
    permission: "FT"
  },
  {
    path: "/finance/report/enquery",
    element: <div />,
    permission: "FT"
  },
  {
    path: "/finance/report/cast-disbursement",
    element: <div />,
    permission: "FT"
  },
  {
    path: "/finance/report/cast-receipts",
    element: <div />,
    permission: "FT"
  },
  {
    path: "/finance/report/by-contact",
    element: <div />,
    permission: "FT"
  },
  {
    path: "/finance/report",
    element: <div />,
    permission: "FT"
  },
]
